import React, { useRef, useState } from 'react';
import cls from './carousel.module.scss';
import ImageGallery, {
    ReactImageGalleryItem,
    ReactImageGalleryProps,
} from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Controls } from './Controls';
import { YoutubeEmbed } from '../youtube-embed';
import clsx from 'clsx';
import Paragraph from '../paragraph';

export interface CarouselItem extends ReactImageGalleryItem {
    embedUrl?: string;
}

interface IProps extends ReactImageGalleryProps {
    items: CarouselItem[];
    className?: string;
    title?: string;
    description?: string;
    subscription?: string;
    cleanComponent?: boolean;
}

export const Carousel = ({ className, title, description, subscription, cleanComponent, ...props }: IProps) => {
    const [scrollY, setScrollY] = useState(0);

    const items = props.items.map((slide): ReactImageGalleryItem => {
        if (slide.embedUrl) {
            return {
                ...slide,
                renderItem: (el) => (
                    <YoutubeEmbed src={slide.embedUrl} {...el} />
                ),
            };
        }
        return slide;
    });

    const galleryRef = useRef(null);

    const clsCarousel = clsx(cls.carousel, {
        [className]: Boolean(className),
    });

    const handleFullscreen = (e: boolean) => {
        if (e) {
            screen.orientation.lock('landscape');
            const posY = window.scrollY;
            setScrollY(posY);
        } else {
            screen.orientation.unlock();
            window.scrollTo(0, scrollY);
        }
    };

    const clsWrapper = clsx({
        [cls.carouselWrapper]: !cleanComponent,
        [className!]: className && !cleanComponent,
    });

    return (
        <div className={clsWrapper}>
            {title && <h3 className={cls.carouselTitle}>{title}</h3>}
            {description && <Paragraph className={cls.text}>{description}</Paragraph>}
            <ImageGallery
                additionalClass={clsCarousel}
                ref={galleryRef}
                items={items}
                showThumbnails={false}
                showPlayButton={false}
                showFullscreenButton={false}
                showBullets={false}
                showIndex={false}
                showNav={false}
                onClick={() => galleryRef.current?.toggleFullScreen()}
                onScreenChange={handleFullscreen}
                renderCustomControls={() => (
                    <Controls
                        slideLeft={galleryRef.current?.slideLeft}
                        slideRight={galleryRef.current?.slideRight}
                        toggleFullScreen={galleryRef.current?.toggleFullScreen}
                        state={galleryRef.current?.state}
                        props={galleryRef.current?.props}
                        showFullScreen={props.showFullscreenButton}
                        showIndex={props.showIndex}
                        showNav={props.showNav}
                    />
                )}
                renderItem={(item) => {
                    const isFullscreen = galleryRef.current?.state?.isFullscreen;
                    const src = !item.thumbnail || isFullscreen ? item.original : item.thumbnail;
                  
                    return <img className="image-gallery-image" src={src} alt={item.description || ''} />;
                 }}
            />
            {subscription && <Paragraph className={cls.subscription}>{subscription}</Paragraph>}
        </div>
    );
};
